import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { TpETLComponentTypeManifest } from '../interfaces';
import { color } from '../../../visual-analytics/helpers/colors';
import { TpETLPipelineComponent, TpETLDryRun, TpETLDryRunComponentResult } from '../../interfaces';
import { TpETLObjectTypes } from '../../etl-data-types/interfaces';
import { ETLDryRunObjectTableAddColumn } from '../utils';
import { VALTYPES } from '../../../../data/interfaces';
import { addDryRunObjectTable } from '../../utils';

function performDryRun(dryRun: TpETLDryRun, comp: TpETLPipelineComponent): TpETLDryRunComponentResult {
  const outputTableObj = addDryRunObjectTable(dryRun, comp.outputObjectIds['result'], comp);
  ETLDryRunObjectTableAddColumn(outputTableObj, 'id', 'ID', 'Unique identifier of the publication', VALTYPES.STRING);
  ETLDryRunObjectTableAddColumn(outputTableObj, 'topics', 'Topics', 'The list of topics', VALTYPES.CATEGORICAL);
  ETLDryRunObjectTableAddColumn(outputTableObj, 'umap_x', 'UMAP X', 'Umapped X coordinate', VALTYPES.NUMBER);
  ETLDryRunObjectTableAddColumn(outputTableObj, 'umap_y', 'UMAP Y', 'Umapped Y coordinate', VALTYPES.NUMBER);
  return {
    abort: false,
  };
}

export const manifestETLTopicClustering: TpETLComponentTypeManifest = {
  id: 'TopicClustering',
  name: 'Topic Clustering',
  description: 'Cluster Articles based on their topics',
  categoryId: 'publications',
  color: color(140, 0, 230),
  icon: <FontAwesomeIcon icon={['fas', 'hexagon-nodes']} />,
  inputs: [
    {
      type: TpETLObjectTypes.TABLE,
      id: 'sourceTable',
      name: 'Source Table',
      columns: [],
    },
  ],
  outputs: [
    {
      id: 'result',
      name: 'Result table',
      type: TpETLObjectTypes.TABLE,
      description: 'Table with the clustered articles',
      columns: [],
    },
  ],
  params: [],
  performDryRun,
};
